import { Address, AddressID } from 'framework/address'
import { UserId } from 'framework/users'
import EcommerceService from 'services/ecommerce-service'

class AddressService extends EcommerceService {
  private id: AddressID = '' as unknown as AddressID

  private customerId: UserId = '' as unknown as UserId

  setId(addressId: AddressID): AddressService {
    this.id = addressId
    return this
  }

  getId() {
    return this.id
  }

  setCustomerId(id: string) {
    this.customerId = id as unknown as UserId
  }

  getCustomer() {
    return this.customerId
  }

  list() {
    console.log(this.getCustomer())
    const url = `/customers/${this.getCustomer().toString()}/address`
    const req = this.setUrl(url).get()
    return req
  }

  getAddressById() {
    const url = `/customers/${this.getCustomer()}/address`
    const req = this.setUrl(url).get()
    return req
  }

  updateAddressById(addressId: AddressID, payload: Address) {
    const url = `/customers/${this.getCustomer()}/address/${addressId}`
    const req = this.setUrl(url).post(payload)
    return req
  }

  createAddress(payload: Address) {
    const url =
      payload.type === 'COBRANCA'
        ? `/customers/${this.getCustomer()}/billing-address`
        : `/customers/${this.getCustomer()}/address`
    const req = this.setUrl(url).post(payload)
    return req
  }

  getAddressByZipcode(zipCode: string) {
    const url = `/viacep/zipcode/${zipCode}`
    const req = this.setUrl(url).get()
    return req
  }

  validateDeliveryArea(zipCode: string) {
    const url = `/shipping/validate-delivery-area/${zipCode}`
    const req = this.setUrl(url).get()
    return req
  }
}

export default AddressService
